import dompurify from 'dompurify';

var ALLOWED_TAGS = ['br', 'p', 'div', 'strong', 'b', 'em', 'cite', 'dfn', 'i', 'big', 'small', 'font', 'blockquote', 'tt', 'u', 'sup', 'sub', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var ALLOWED_ATTR = ['color', 'src', 'face'];

export default (function () {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var textStr = String(text);

    if (!dompurify.isSupported) {
        return textStr;
    }

    return dompurify.sanitize(textStr, {
        ALLOWED_TAGS: ALLOWED_TAGS,
        ALLOWED_ATTR: ALLOWED_ATTR
    });
});